"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accessor_1 = require("../../../models/Accessor");
var core_1 = require("../core");
var definedStartDateWindow_1 = require("../types/definedStartDateWindow");
var latestDataDateWindow_1 = require("../types/latestDataDateWindow");
var customDateWindow_1 = require("../types/customDateWindow");
var lastNDateWindow_1 = require("../types/lastNDateWindow");
var allTimeDateWindow_1 = require("../types/allTimeDateWindow");
var dateWindowOptions_1 = require("./dateWindowOptions");
exports.dateWindowOptions = dateWindowOptions_1.dateWindowOptions;
var defaultDateWindow_1 = require("./defaultDateWindow");
exports.defaultDateWindow = defaultDateWindow_1.defaultDateWindow;
exports.applyWindow = function (metricTable, dateWindow, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    return core_1.applyWindowFunction(metricTable, exports.windowFuncFromWindow(dateWindow, accessor));
};
exports.windowFuncFromWindow = function (dateWindow, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    switch (dateWindow.type) {
        case core_1.DateWindowTypes.CUSTOM:
            var customWindow = dateWindow;
            return customDateWindow_1.customDateWindow(customWindow.range, accessor);
        case core_1.DateWindowTypes.LAST_N:
            var lastNWindow = dateWindow;
            return lastNDateWindow_1.lastNDateWindow(lastNWindow.n);
        case core_1.DateWindowTypes.LATEST_DATA:
            var latestWindow = dateWindow;
            return latestDataDateWindow_1.latestDataDateWindow(latestWindow.duration, accessor);
        case core_1.DateWindowTypes.DEFINED_START:
            var definedStartDateDateWindow = dateWindow;
            return definedStartDateWindow_1.definedStartDateWindow(definedStartDateDateWindow.startDate, accessor);
        case core_1.DateWindowTypes.SPECIAL:
        default:
            return allTimeDateWindow_1.allTimeDateWindow();
    }
};
//# sourceMappingURL=index.js.map